/** Paths teachers may visit while previewing the student welcome experience. */
export function isTeacherAllowedPath(pathname: string): boolean {
  if (pathname === '/' || pathname === '/overview' || pathname === '/school-selection') {
    return true;
  }

  const allowedPrefixes = [
    '/tasklist',
    '/task/',
    '/checklist',
    '/learning-center',
    '/classroom-materials',
    '/help-and-support',
    '/support',
    '/schoolinfo',
  ];

  return allowedPrefixes.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix)
  );
}
